(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-coupon"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pcouponInit) return;
    window.__pcouponInit = true;

    /* Puts the code on the cart itself, so it carries to checkout on any domain. */
    function applyCode(code) {
      var cookieStep = fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), {
        credentials: 'same-origin',
      }).catch(function () {});

      return cookieStep
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code }),
          });
        })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (!cart) return { ok: false, applicable: false };
          var match = (cart.discount_codes || []).filter(function (d) {
            return String(d.code).toLowerCase() === String(code).toLowerCase();
          })[0];
          return { ok: true, applicable: !!(match && match.applicable) };
        });
    }

    function copyCode(code) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(code).catch(function () {});
        }
      } catch (e) {}
      return Promise.resolve();
    }

    function show(root, result) {
      var button = root.querySelector('[data-pcoupon-button]');
      var status = root.querySelector('[data-pcoupon-status]');
      if (!button || !status) return;
      if (result.ok && result.applicable) {
        button.textContent = button.dataset.appliedLabel;
        button.disabled = true;
        status.textContent = button.dataset.msgApplied;
      } else if (result.ok) {
        status.textContent = button.dataset.msgSaved;
      } else {
        status.textContent = button.dataset.msgError;
      }
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pcoupon-button]');
      if (!button) return;
      var root = button.closest('[data-pcoupon]');
      var code = root && root.dataset.code;
      if (!code) return;
      copyCode(code);
      applyCode(code)
        .then(function (result) {
          show(root, result);
        })
        .catch(function () {
          show(root, { ok: false });
        });
    });

    /* After the product is added to the cart, apply the code again so it is on the cart for checkout. */
    document.addEventListener('cart:update', function (event) {
      var data = event.detail && event.detail.data;
      if (data && data.didError) return;
      var root = document.querySelector('[data-pcoupon][data-auto-apply="true"]');
      if (!root || root.dataset.busy === '1') return;
      var button = root.querySelector('[data-pcoupon-button]');
      if (button && button.disabled) return;
      root.dataset.busy = '1';
      applyCode(root.dataset.code)
        .then(function (result) {
          show(root, result);
        })
        .catch(function () {})
        .then(function () {
          root.dataset.busy = '0';
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
